// extracted by mini-css-extract-plugin
export default {"container":"styles_container__NS8FO","header":"styles_header__MiReL","content":"styles_content__T2jta","buttonWrapper":"styles_buttonWrapper__aj6tx"};